// src/pages/AdminInbox.jsx
import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../auth/firebaseClient";
import { useAuth } from "../auth/AuthContext";
import { Card, CardHeader, CardTitle, CardContent } from "../components/ui/card";
import { t } from "../i18n/translations";
import { useLanguage } from "../i18n/LanguageContext";

export default function AdminInbox() {
    const { currentUser } = useAuth();
    const [items, setItems] = useState([]);
    const { language } = useLanguage();
    const locale = language === "ar" ? "ar" : language === "he" ? "he" : "en";
    const dateFormatter = useMemo(
        () => new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }),
        [locale]
    );

    useEffect(() => {
        const q = query(collection(db, "contactMessages"), orderBy("createdAt", "desc"));
        const unsub = onSnapshot(q, (qs) => {
            setItems(qs.docs.map(d => ({ id: d.id, ...d.data() })));
        }, (err) => console.error("Inbox snapshot error:", err));
        return () => unsub();
    }, []);

    if (!currentUser || currentUser.role !== "admin") {
        return <div className="p-8 text-sm text-muted-foreground">{t("adminInbox.restricted", language)}</div>;
    }

    return (
        <section className="py-16">
            <Card className="rounded-2xl">
                <CardHeader>
                    <CardTitle className="text-xl">{t("adminInbox.title", language)}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    {items.length === 0 ? (
                        <div className="text-sm text-muted-foreground">{t("adminInbox.empty", language)}</div>
                    ) : items.map(m => (
                        <div key={m.id} className="rounded-xl border p-4 space-y-1">
                            <div className="text-sm"><span className="font-medium">{m.name}</span> &lt;{m.email}&gt;</div>
                            {m.subject ? (
                                <div className="text-sm text-slate-500">{t("adminInbox.subject", language)}: {m.subject}</div>
                            ) : null}
                            <div className="text-sm whitespace-pre-wrap">{m.message}</div>
                            <div className="text-xs text-slate-500">
                                {m.createdAt?.toDate
                                    ? dateFormatter.format(m.createdAt.toDate())
                                    : t("adminInbox.timestampPending", language)}
                            </div>
                        </div>
                    ))}
                </CardContent>
            </Card>
        </section>
    );
}
